import { render } from "./ErrorAuthView.vue?vue&type=template&id=724c6fac&scoped=true"
import script from "./ErrorAuthView.vue?vue&type=script&lang=js"
export * from "./ErrorAuthView.vue?vue&type=script&lang=js"

import "./ErrorAuthView.vue?vue&type=style&index=0&id=724c6fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724c6fac"]])

export default __exports__